import React, { Component } from 'react'
import { debounce } from 'lodash'
import { fit } from '../utils'
import { t } from 'i18next'

class Explanation extends Component {
  state = {
    height: window.innerHeight
  }

  constructor(props) {
    super(props)
    this.resize = this.resize.bind(this)
  }

  componentDidMount() {
    setTimeout(() => {
      fit(this.text)
    }, 50)

    window.addEventListener('resize', this.resize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = debounce(() => {
    this.setState({
      height: window.innerHeight
    })

    setTimeout(() => {
      this.text.style.fontSize = '22px'
      fit(this.text)
    }, 50)
  }, 100)

  render() {
    const { question, last, nextStep } = this.props
    const { height } = this.state
    const card = height > 650 ? 302 : 230
    return (
      <div className="explanation">
        <div
          style={{
            height: card,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center'
          }}
        >
          <div
            style={{
              maxHeight: card,
              padding: '1rem 2rem',
              width: '100%'
            }}
            ref={r => (this.text = r)}
          >
            {question.Explanation}
          </div>
        </div>
        <button style={{ marginTop: '1.4rem' }} className="btn btn-blue btn-base full" onClick={e => nextStep()}>
          {last ? t('trivia.end') : t('trivia.next')}
        </button>
      </div>
    )
  }
}

export default Explanation



// WEBPACK FOOTER //
// ./src/components/Explanation.js